<mat-chip
	class="label-badge limited-width"
	[ngStyle]="{
		'--background-color': label()?.color,
	}"
	[matTooltip]="showTooltip() ? label()?.name : ''"
>
	<span class="label-color-dot"></span>
	<span
		[ngClass]="{
			'label-text': true,
			ellipsis: showTooltip(),
		}"
		>{{ label()?.name }}</span
	>

	@if (showCloseButton()) {
		<mat-icon
			matRipple
			class="cursor-pointer icon"
			(click)="closeIconClicked.emit(label())"
			svgIcon="close"
		/>
	}
</mat-chip>
